import { clampPercent, localizedName, sortResultPatterns, toFiniteNumber } from 'shared/utilities/format';

export function ResultScoreBars({ patterns = [], locale = 'en', tiedLabel = 'Tie' }) {
  const rows = sortResultPatterns(patterns);

  return (
    <div className="score-stack">
      {rows.map((pattern) => {
        const percent = toFiniteNumber(pattern.percentage, 0);
        const width = clampPercent(percent);
        const percentLabel = pattern.percentage == null || pattern.percentage === ''
          ? '—'
          : `${percent.toFixed(2)}%`;
        return (
          <article key={pattern.id || pattern.version_pattern_id || pattern.slug} className="score-card">
            <div className="score-card-copy">
              <strong>{localizedName(pattern, locale)}</strong>
              <span>
                {percentLabel}
                {pattern.is_tied ? ` · ${tiedLabel}` : ''}
              </span>
            </div>
            <div
              className="score-track"
              role="meter"
              aria-valuemin={0}
              aria-valuemax={100}
              aria-valuenow={width}
              aria-label={`${localizedName(pattern, locale)} ${percent.toFixed(2)}%${pattern.is_tied ? ` ${tiedLabel}` : ''}`}
            >
              <div
                className="score-fill"
                style={{
                  width: `${width}%`,
                  background: pattern.color || '#0f766e',
                }}
              />
            </div>
          </article>
        );
      })}
    </div>
  );
}
